import { useCallback } from "react"

import { MEZO_CHAIN } from "#/shared/constants"

import VeBTCAbi, {
  address as veBTCAddress,
} from "../../constants/artifacts/VeBTC"
import { useWriteContractAndWaitForTransaction } from "../contract"

type IncreaseStakeAmountVariables = { amount: bigint; stakeId: string | number }

const useIncreaseStakeAmount = () => {
  const { writeContractAsync, ...rest } = useWriteContractAndWaitForTransaction(
    MEZO_CHAIN.id,
  )

  const increaseAmount = useCallback(
    async (
      { amount, stakeId }: IncreaseStakeAmountVariables,
      options?: { onError?: (error: unknown) => void; onSuccess?: () => void },
    ) => {
      await writeContractAsync(
        {
          abi: VeBTCAbi,
          address: veBTCAddress,
          functionName: "increaseAmount",
          args: [BigInt(stakeId), amount],
          chainId: MEZO_CHAIN.id,
        },
        options,
      )
    },
    [writeContractAsync],
  )

  return {
    ...rest,
    increaseAmount,
  }
}

export default useIncreaseStakeAmount
